import { useNavigate } from 'react-router-dom';

function Terms() {
    const navigate = useNavigate();

    return (
        <div style={{ maxWidth: '680px', margin: '0 auto', padding: '60px 32px', fontFamily: 'Helvetica Neue, Arial, sans-serif', color: '#111' }}>

            {/* Back */}
            <p
                onClick={() => navigate(-1)}
                style={{ fontSize: '12px', color: '#aaa', cursor: 'pointer', marginBottom: '48px', letterSpacing: '0.05em' }}
            >
                ← back
            </p>

            {/* Header */}
            <h1 style={{ fontWeight: 'normal', fontSize: '28px', marginBottom: '8px', letterSpacing: '0.02em' }}>
                Contributor Terms
            </h1>
            <p style={{ fontSize: '13px', color: '#aaa', marginBottom: '48px' }}>
                winston.ie — last updated May 2026
            </p>

            {/* Intro */}
            <p style={{ fontSize: '14px', lineHeight: '1.9', color: '#444', marginBottom: '40px' }}>
                These terms govern the relationship between winston.ie and any individual ("contributor") who publishes creative work on the platform. By publishing on winston.ie, you acknowledge and agree to the following.
            </p>

            {/* Section 1 */}
            <Section number="1" title="Copyright">
                <p>
                    You retain full copyright over all work you publish on winston.ie. Publishing on this platform does not transfer intellectual property ownership to winston.ie or any third party.
                </p>
            </Section>

            {/* Section 2 */}
            <Section number="2" title="Label agreement & licence">
                <p>
                    By publishing on winston.ie, you grant winston.ie a worldwide, royalty-free licence to publish, display, share, distribute, and commercially use your work as part of the winston.ie platform and its associated projects — including but not limited to partnerships, collaborations, promotional campaigns, and external exhibitions.
                </p>
                <p>
                    This licence is granted for the duration of your work's presence on the platform. You may request removal at any time by contacting winston.ie directly (see Section 6).
                </p>
            </Section>

            {/* Section 3 */}
            <Section number="3" title="Exclusivity">
                <p>
                    Work published on winston.ie is published exclusively through this platform. You agree not to publish the same work on any other public platform, portfolio, or distribution channel without prior written permission from winston.ie.
                </p>
                <p>
                    This exclusivity applies to the specific works published, not to your creative practice as a whole. You remain free to create and publish new, original works elsewhere.
                </p>
            </Section>

            {/* Section 4 */}
            <Section number="4" title="Intermediary & representation">
                <p>
                    winston.ie acts as your label and sole representative for any third-party requests involving your published work — including usage requests, reproduction, licensing to external parties, and collaboration opportunities.
                </p>
                <p>
                    Any such request will be communicated to you. Your explicit written consent is required before any external use is approved. winston.ie will not act on your behalf without your knowledge.
                </p>
            </Section>

            {/* Section 5 */}
            <Section number="5" title="Commercial revenue">
                <p>
                    If your published work generates commercial revenue through winston.ie — whether through licensing, partnerships, sales, or other means — a revenue-sharing arrangement will be discussed and agreed upon separately with you prior to any commercial transaction.
                </p>
                <p>
                    winston.ie commits to transparency in all revenue matters involving contributor work.
                </p>
            </Section>

            {/* Section 6 */}
            <Section number="6" title="Credit">
                <p>
                    You will always be credited as the original creator on all content published, shared, or distributed through winston.ie or on its behalf. Credit will include your name as provided at the time of publishing.
                </p>
            </Section>

            {/* Section 7 */}
            <Section number="7" title="Removal & withdrawal">
                <p>
                    You may request the removal of your published work at any time by contacting winston.ie at{' '}
                    <a href="mailto:contact@winston.longden.site" style={{ color: '#111' }}>contact@winston.longden.site</a>.
                    Removal requests will be processed within 14 days. Upon removal, the licence granted under Section 2 is terminated for future use, though existing third-party agreements entered into prior to removal remain valid.
                </p>
            </Section>

            {/* Section 8 */}
            <Section number="8" title="Governing law">
                <p>
                    These terms are governed by the laws of the Province of Quebec and the federal laws of Canada applicable therein. Any disputes shall be resolved in the courts of Montreal, Quebec.
                </p>
            </Section>

            {/* Footer */}
            <div style={{ marginTop: '64px', paddingTop: '24px', borderTop: '1px solid #e0e0e0' }}>
                <p style={{ fontSize: '12px', color: '#aaa', lineHeight: '1.8' }}>
                    © winston.ie 2026 — All works published on this platform are exclusively licensed to winston.ie.
                    For collaboration or usage requests, contact{' '}
                    <a href="mailto:contact@winston.longden.site" style={{ color: '#888' }}>contact@winston.longden.site</a>.
                </p>
            </div>

        </div>
    );
}

function Section({ number, title, children }) {
    return (
        <div style={{ marginBottom: '36px' }}>
            <h2 style={{ fontWeight: 'normal', fontSize: '16px', marginBottom: '12px', display: 'flex', gap: '12px', alignItems: 'baseline' }}>
                <span style={{ fontSize: '11px', color: '#aaa', letterSpacing: '0.1em' }}>{number}.</span>
                {title}
            </h2>
            <div style={{ fontSize: '13px', color: '#555', lineHeight: '1.9', display: 'flex', flexDirection: 'column', gap: '10px' }}>
                {children}
            </div>
        </div>
    );
}

export default Terms;